import { type Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getOutOfStockModifications(
  initialModifications: Modification[],
) {
  return initialModifications.filter(checkIfOutOfStock);
}

export function getOutOfStockModificationNames(
  initialModifications: Modification[],
) {
  return getOutOfStockModifications(initialModifications)
    .map(extractModificationName)
    .filter(Boolean)
    .join(', ');
}

export function checkIfInStock(modification: Modification): boolean {
  return !modification.outOfStock;
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfOutOfStock(modification: Modification): boolean {
  return modification.outOfStock === true;
}

function extractModificationName(modification: Modification) {
  return modification.ingredient?.name;
}
